import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggingService } from '@services/logging.service';
import { HttpClient } from '@angular/common/http';
import { Adjustment } from './adjustment.model';
import { UserNotificationService } from '@services/user-notification.service';

export const ADJUSTMENT_URL = '/api/Adjustments';

@Injectable({
  providedIn: 'root',
})
export class AdjustmentsService {
  constructor(private logger: LoggingService, private http: HttpClient, private userNotificationService: UserNotificationService) {}

  // MK todo( 2020-05-12 ) create a backend story for this endpoint, consider changing the tested party to return adjustment records (getBySearchStrategyId)
  getByTestedPartyId(testedPartyId: number): Observable<Adjustment> {
    const url = ADJUSTMENT_URL + '/testedPartyId/' + testedPartyId;
    return this.http.get<Adjustment>(url).pipe(
      catchError((error) => {
        this.logger.httpError(this.constructor.name, url, error);
        return throwError(() => error);
      })
    );
  }

  getBySearchStrategyId(searchStrategyId: number): Observable<Adjustment[]> {
    const url = ADJUSTMENT_URL + '/studySearchStrategyId/' + searchStrategyId;
    return this.http.get<Adjustment[]>(url).pipe(
      catchError((error) => {
        this.logger.httpError(this.constructor.name, url, error);
        return throwError(() => error);
      })
    );
  }

  updateInsert(adjustment: Adjustment): Observable<any> {
    if (adjustment.adjustmentId) {
      return this.http.put(ADJUSTMENT_URL, adjustment).pipe(
        catchError((error) => {
          this.logger.httpError(this.constructor.name, ADJUSTMENT_URL, error);
          return throwError(() => error);
        })
      );
    }

    return this.http.post(ADJUSTMENT_URL, adjustment).pipe(
      catchError((error) => {
        this.logger.httpError(this.constructor.name, ADJUSTMENT_URL, error);
        return throwError(() => error);
      })
    );
  }
}
